module.exports = __webpack_public_path__ + "img/event-4.708bf9f.jpg";